<template>
  <div class="page_main">
    <div class="left side_list">
      <div class="general_box item_box">
        <div class="item_title_box">电梯概况</div>
        <div class="general_content">
          <div class="item_box">
            <div class="item_list">
              <img class="icon" src="@/assets/image/d1.png" alt="" />
              <div class="list_desc">
                <div class="label">电梯</div>
                <div class="num">{{ formData.totalElevators }}<span>台</span></div>
              </div>
            </div>
            <div class="item_list">
              <img class="icon" src="@/assets/image/d2.png" alt="" />
              <div class="list_desc">
                <div class="label">物联网电梯</div>
                <div class="num">{{ formData.iotElevators }}<span>台</span></div>
              </div>
            </div>
            <div class="item_list">
              <img class="icon" src="@/assets/image/d3.png" alt="" />
              <div class="list_desc">
                <div class="label">在线电梯</div>
                <div class="num">{{ formData.onlineElevators }}<span>台</span></div>
              </div>
            </div>
            <div class="item_list">
              <img class="icon" src="@/assets/image/d4.png" alt="" />
              <div class="list_desc">
                <div class="label">离线电梯</div>
                <div class="num">{{ formData.offlineElevators }}<span>台</span></div>
              </div>
            </div>
          </div>
          <div class="line" />
          <div class="item_box">
            <div class="item_list">
              <img class="icon" src="@/assets/image/d5.png" alt="" />
              <div class="list_desc">
                <div class="label">使用单位数量</div>
                <div class="num">{{ formData.usageUnit }}</div>
                <!-- <div class="num">30</div> -->
              </div>
            </div>
            <div class="item_list">
              <img class="icon" src="@/assets/image/d6.png" alt="" />
              <div class="list_desc">
                <div class="label">物联网覆盖率</div>
                <div class="num">
                  {{ ((formData.iotElevators / formData.totalElevators) * 100).toFixed(2)
                  }}<span>%</span>
                </div>
              </div>
            </div>
            <div class="item_list">
              <img class="icon" src="@/assets/image/d7.png" alt="" />
              <div class="list_desc">
                <div class="label">物联网在线率</div>
                <div class="num">
                  {{
                    ((formData.onlineElevators / formData.iotElevators) * 100).toFixed(2)
                  }}<span>%</span>
                </div>
              </div>
            </div>
            <div class="item_list">
              <img class="icon" src="@/assets/image/d8.png" alt="" />
              <div class="list_desc">
                <div class="label">物联网离线率</div>
                <div class="num">
                  {{
                    (
                      ((formData.iotElevators - formData.onlineElevators) /
                        formData.iotElevators) *
                      100
                    ).toFixed(2)
                  }}<span>%</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="thirtydays_box item_box">
        <div class="item_title_box">电梯梯龄统计板块内容</div>
        <!-- <div class="item_title_box">近30天故障分布统计</div> -->
        <div class="thirtydays_content" id="malfunction"></div>
      </div>
      <div class="charts_bottom_box item_box">
        <div class="item_title_box">近30天告警类型统计</div>
        <div class="charts_container" id="warnTypeThirty"></div>
      </div>
    </div>
    <div class="center">
      <div class="map_box">
        <div class="back" v-if="showBack()" @click="backToProvince"></div>
        <div class="map_content" id="map"></div>
      </div>
      <div class="center_bottom">
        <div class="charts_bottom_box item_box">
          <div class="item_title_box">近7天电梯告警率趋势</div>
          <div class="charts_container" id="warnTypeSeven"></div>
        </div>
        <div class="charts_bottom_box item_box">
          <div class="item_title_box">近30天困人次数趋势</div>
          <div class="charts_container" id="warnTime"></div>
        </div>
      </div>
    </div>
    <div class="right side_list">
      <div class="today_warn_box item_box">
        <div class="item_title_box">今日告警</div>
        <div class="today_warn_content">
          <div class="today_charts" id="warnToday"></div>
          <div class="today_legend">
            <div class="legend_list">
              <img class="icon" src="@/assets/image/l1.png" alt="" />
              <img class="line" src="@/assets/image/line1.png" alt="" />
              <div class="value_box">
                <div class="status">
                  <img class="arrow" src="@/assets/image/ar1.png" alt="" />
                  已解除
                </div>
                <div class="value">{{ formData.daysRelieveNo }}</div>
              </div>
            </div>
            <div class="legend_list">
              <img class="icon" src="@/assets/image/l2.png" alt="" />
              <img class="line" src="@/assets/image/line2.png" alt="" />
              <div class="value_box">
                <div class="status warn">
                  <img class="arrow" src="@/assets/image/ar2.png" alt="" />
                  维修中
                </div>
                <div class="value">{{ formData.serviceNo }}</div>
              </div>
            </div>
            <div class="legend_list">
              <img class="icon" src="@/assets/image/l3.png" alt="" />
              <img class="line" src="@/assets/image/line3.png" alt="" />
              <div class="value_box">
                <div class="status danger">
                  <img class="arrow" src="@/assets/image/ar3.png" alt="" />
                  未解除
                </div>
                <div class="value">{{ formData.dayNotNo }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="real_time item_box">
        <div class="item_title_box">近30天告警维保单位TOP10</div>
        <div class="real_content">
          <div class="real_box">
            <div
              class="swiper-wrapper"
              v-for="(item, index) in realWarnList"
              :key="index"
            >
              <!-- <div
              class="swiper-wrapper"
              v-for="(item, index) in 5"
              :key="index"
              @click="lookMask"
            > -->
              <div class="real_list swiper-slide">
                <div class="item_list">
                  <div class="label_box">
                    <!-- <div class="tag">未解除</div> -->
                    <div class="tag2">{{ item.faultType }}</div>
                    <div class="text">超期未保养数量 {{ item.count }}</div>
                    <div class="warn_bottom">
                      <!-- <div class="text">{{ item.aa }}</div> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <img
              v-if="realWarnList.length == 0"
              class="nothing"
              src="@/assets/image/nothing.png"
              alt=""
            />
          </div>
        </div>
      </div>
      <div class="charts_bottom_box item_box">
        <div class="item_title_box">近30天告警使用单位TOP10</div>
        <div class="charts_container use_box">
          <div class="swiper-wrapper">
            <div
              class="unit_list swiper-slide"
              v-for="(item, index) in thirtyWarnUnit"
              :key="index"
            >
              <div class="sort_item">
                <div class="sort_info">
                  <img v-if="index == 0" class="icon" src="@/assets/image/n1.png" />
                  <img v-if="index == 1" class="icon" src="@/assets/image/n2.png" />
                  <img v-if="index == 2" class="icon" src="@/assets/image/n3.png" />
                  <div class="sort">NO.{{ index + 1 }} {{ item.faultType }}</div>
                  <div :class="index == 0 ? 'value first' : 'value'">
                    {{ item.count }}
                  </div>
                </div>
                <div class="process_box">
                  <div
                    :class="index == 0 ? 'process active' : 'process'"
                    :style="
                      'width:' + (unitTotal ? Number(item.count) / unitTotal : 0) + '%;'
                    "
                  >
                    <div class="process_line"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <TheMask ref="mask" />
  </div>
</template>

<script>
import { getDataCenter, getMapData, getBoardData } from "@/api/user";
import { areaIdMap, areaNameMap, mapDataToEcharts } from "@/utils";

import Swiper from "swiper"; // 注意引入的是Swiper
import * as echarts from "echarts";
import TheMask from "../theMask/index.vue";

import hubeiGeoJson from "@/utils/map.json"; // 湖北省geojson
// 市区geojson示例引入写法（实际建议动态import或按需加载）
import shiyan from "@/utils/cities/shiyan.json";
import shennongjia from "@/utils/cities/shennongjia.json";
import enshi from "@/utils/cities/enshi.json";
import xiangyang from "@/utils/cities/xiangyang.json";
import yichang from "@/utils/cities/yichang.json";
import suizhou from "@/utils/cities/suizhou.json";
import jingmen from "@/utils/cities/jingmen.json";
import jingzhou from "@/utils/cities/jingzhou.json";
import xiaogan from "@/utils/cities/xiaogan.json";
import tianmen from "@/utils/cities/tianmen.json";
import qianjiang from "@/utils/cities/qianjiang.json";
import xiantao from "@/utils/cities/xiantao.json";
import wuhan from "@/utils/cities/wuhan.json";
import huanggang from "@/utils/cities/huanggang.json";
import ezhou from "@/utils/cities/ezhou.json";
import huangshi from "@/utils/cities/huangshi.json";
import xianning from "@/utils/cities/xianning.json";
export default {
  name: "IndexHome",
  components: {
    TheMask,
  },
  data() {
    return {
      formData: {},
      thirtyFault: [],
      thirtyWarnType: [],
      sevenWarn: [],
      thirtyWarnTime: [],
      thirtyWarnUnit: [],
      boardForm: {},
      unitTotal: 0,
      currentLevel: "province", // 省级或市级
      currentMapName: "hubei", // 当前注册的地图名称
      // url: "wss://lift.yqdiot.cn/websocket/eventMessage",
      // url: "ws://192.168.0.103:8380/websocket/eventMessage",
      // webSocket: null,
      first: true,
      realWarnList: [],
      code: "",
      parentCode: "",
      codeText: "",
      codeList: [
        "420100",
        "420200",
        "420300",
        "420500",
        "420600",
        "420700",
        "420800",
        "420900",
        "421000",
        "421100",
        "421200",
        "421300",
        "422800",
        "429004",
        "429005",
        "429006",
        "429021",
      ],
    };
  },
  mounted() {
    const query = window.location.hash.split("?")[1];
    // 解析 URL 参数
    const urlParams = new URLSearchParams(query);
    const token = urlParams.get("token");
    const code = urlParams.get("code");
    if (code) {
      console.log("App.vue 中获取的 token:", code);
      localStorage.setItem("code", code); // 或存到 Vuex
    }
    if (token) {
      console.log("App.vue 中获取的 token:", token);
      localStorage.setItem("token", token); // 或存到 Vuex
    }

    this.$nextTick(() => {
      // this.join();
      this.getData();
      this.initWarnToday();
      this.code = localStorage.getItem("code");
      if (
        this.code == "429004" ||
        this.code == "429005" ||
        this.code == "429006" ||
        this.code == "429021"
      ) {
        this.parentCode = this.code;
      } else {
        this.parentCode = this.code.slice(0, 4) + "00";
      }
      this.codeText = areaIdMap[Number(this.parentCode)] || null;
      if (this.codeText) {
        this.currentLevel = "city";
        this.loadCityMap(this.codeText);
      } else {
        this.initMap();
      }
    });
  },
  destroyed() {
    this.exit();
  },
  // watch: {
  //   realWarnList() {
  //     this.$nextTick(() => {
  //       this.swiperInitWarn(); // 等 DOM 更新完成再初始化 Swiper
  //     });
  //   },
  // },
  methods: {
    showBack() {
      if (this.currentLevel !== "city") {
        return false;
      } else {
        if (this.codeList.includes(this.code)) {
          return true;
        } else {
          return false;
        }
      }
    },
    // join() {
    //   const wsuri = this.url;
    //   let that = this;
    //   this.webSocket = new WebSocket(wsuri);
    //   this.webSocket.onopen = function (event) {
    //     console.log("连接成功");
    //     that.text_content = that.text_content + "已经打开连接!" + "\n";
    //   };
    //   this.webSocket.onmessage = function (event) {
    //     if (that.first) {
    //       that.send();
    //       that.first = false;
    //     }
    //     //接收消息
    //     console.log("接收消息", event);
    //     that.text_content = event.data + "\n";
    //     //接收消息处理

    //     if (event.data !== "连接成功" && event.data !== "heart") {
    //       console.log(JSON.parse(event.data), "event.dataevent.data");
    //       that.realWarnList = [JSON.parse(event.data)];
    //       setInterval(() => {
    //         that.send();
    //       }, 10000);
    //     }
    //   };
    //   this.webSocket.onerror = function (error) {
    //     console.error("WebSocket 出错", error);
    //     that.join();
    //   };
    //   this.webSocket.onclose = function (event) {
    //     that.text_content = that.text_content + "已经关闭连接!" + "\n";
    //   };
    // },
    // exit() {
    //   if (this.webSocket) {
    //     this.webSocket.close();
    //     this.webSocket = null;
    //   }
    // },
    // send() {
    //   if (this.webSocket) {
    //     this.webSocket.send(localStorage.getItem("token"));
    //   } else {
    //     // alert("未连接到服务器");
    //   }
    // },
    getData() {
      getDataCenter().then((res) => {
        this.formData = res.data;
        this.thirtyFault = res.data?.elevatorFaultStatVos;
        this.thirtyWarnType = res.data?.elevatorTypeVos;
        this.sevenWarn = res.data?.sevenDayElevatorListVos;
        this.thirtyWarnTime = res.data?.thirtyDaysElevatorListVos;
        this.thirtyWarnUnit = res.data?.unitElevatorListVos;
        this.realWarnList = res.data?.wbElevatorListVos;

        this.unitTotal = 0;
        res.data?.unitElevatorListVos.map((item) => {
          this.unitTotal += Number(item.count);
        });
        this.$nextTick(() => {
          this.swiperInitUseUnit();
          // this.initMalfunction();
          this.initWarnType();
          this.initWarnTypeSeven();
          this.initWarnTime();
          this.swiperInitWarn(); // 等 DOM 更新完成再初始化 Swiper
        });
      });
      getBoardData().then((res) => {
        this.boardForm = res.data;
        this.$nextTick(() => {
          this.initMalfunction();
        });
      });
    },
    initMap(mapName = "hubei", geoJson = hubeiGeoJson, mapTitle = "湖北省") {
      const myChart = echarts.init(document.getElementById("map"));
      this.myChart = myChart;
      echarts.registerMap(mapName, geoJson);
      if (this.currentLevel == "province") {
        getMapData({
          areaId: "42",
        }).then((res) => {
          const cityData = mapDataToEcharts(res.data);
          const option = {
            title: {
              text: mapTitle,
              left: "center",
              textStyle: {
                color: "#fff", // 这里设置你想要的颜色，比如橙色
                fontSize: 18, // 也可以设置字体大小
                fontWeight: "bold", // 加粗（可选）
              },
            },
            tooltip: {
              trigger: "item",
              formatter: function (params) {
                if (params.value) return `${params.name}: ${params.value}`;
                return params.name;
              },
            },
            series: [
              {
                name: mapTitle,
                type: "map",
                map: mapName,
                roam: false,
                zoom: 1.15,
                label: { show: true },
                itemStyle: {
                  areaColor: "#8FB8D6",
                  borderColor: "#404a59",
                },
                emphasis: {
                  label: { show: true, color: "#fff", fontWeight: "bold" },
                  itemStyle: { areaColor: "#f0a31a" },
                },
                data: cityData,
              },
            ],
          };
          myChart.setOption(option);
          // 点击事件，切换市区地图
          myChart.off("click");
          myChart.on("click", (params) => {
            if (this.currentLevel === "province") {
              const cityName = params.name;
              this.loadCityMap(cityName);
            }
          });
        });
      } else {
        getMapData({
          areaId: areaNameMap[mapTitle] || mapTitle,
        }).then((res) => {
          const cityData = mapDataToEcharts(res.data, geoJson);
          const option = {
            title: {
              text: mapTitle,
              left: "center",
              textStyle: {
                color: "#fff", // 这里设置你想要的颜色，比如橙色
                fontSize: 18, // 也可以设置字体大小
                fontWeight: "bold", // 加粗（可选）
              },
            },
            tooltip: {
              trigger: "item",
              formatter: function (params) {
                if (params.value) return `${params.name}: ${params.value}`;
                return params.name;
              },
            },
            series: [
              {
                name: mapTitle,
                type: "map",
                map: mapName,
                roam: false,
                zoom: 1.15,
                label: { show: true },
                itemStyle: {
                  areaColor: "#8FB8D6",
                  borderColor: "#404a59",
                },
                emphasis: {
                  label: { show: true, color: "#fff", fontWeight: "bold" },
                  itemStyle: { areaColor: "#f0a31a" },
                },
                data: cityData,
              },
            ],
          };
          myChart.setOption(option);
        });
      }
    },
    loadCityMap(cityName) {
      console.log(cityName, "cityNamecityNamecityName");
      // 市名转拼音映射（示例，建议完善）
      const cityMap = {
        十堰市: { mapName: "shiyan", geoJson: shiyan },
        神农架林区: { mapName: "shennongjia", geoJson: shennongjia },
        恩施土家族苗族自治州: { mapName: "enshi", geoJson: enshi },
        襄阳市: { mapName: "xiangyang", geoJson: xiangyang },
        宜昌市: { mapName: "yichang", geoJson: yichang },
        随州市: { mapName: "suizhou", geoJson: suizhou },
        荆门市: { mapName: "jingmen", geoJson: jingmen },
        荆州市: { mapName: "jingzhou", geoJson: jingzhou },
        孝感市: { mapName: "xiaogan", geoJson: xiaogan },
        天门市: { mapName: "tianmen", geoJson: tianmen },
        潜江市: { mapName: "qianjiang", geoJson: qianjiang },
        仙桃市: { mapName: "xiantao", geoJson: xiantao },
        武汉市: { mapName: "wuhan", geoJson: wuhan },
        黄冈市: { mapName: "huanggang", geoJson: huanggang },
        鄂州市: { mapName: "ezhou", geoJson: ezhou },
        黄石市: { mapName: "huangshi", geoJson: huangshi },
        咸宁市: { mapName: "xianning", geoJson: xianning },
        // 其他市对应json要补充
      };
      const city = cityMap[cityName];
      if (!city) {
        alert("未找到该市的地图数据！");
        return;
      }
      this.currentLevel = "city";
      this.currentMapName = city.mapName;
      if (this.myChart) {
        this.myChart.dispose(); // 销毁原图实例
      }
      this.initMap(city.mapName, city.geoJson, cityName); // 传入市区地图参数
    },
    backToProvince() {
      if (this.currentLevel === "city") {
        this.currentLevel = "province";
        this.currentMapName = "hubei";
        this.myChart.dispose();
        this.initMap("hubei", hubeiGeoJson, "湖北省");
      }
    },
    lookMask() {
      console.log("asdasd");
      this.$refs.mask.open();
    },
    swiperInitUseUnit() {
      new Swiper(".use_box", {
        slidesPerView: "4",
        loop: true, // 循环模式选项
        direction: "vertical", // 垂直切换选项
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        }, //可选选项，自动滑动
        spaceBetween: 0,
      });
    },
    swiperInitWarn() {
      if (this.realWarnList.length > 1) {
        new Swiper(".real_box", {
          slidesPerView: 2,
          loop: true, // 循环模式选项
          direction: "vertical", // 垂直切换选项
          autoplay: {
            delay: 3000,
            disableOnInteraction: false,
          }, //可选选项，自动滑动
          spaceBetween: 0,
        });
      }
    },

    initWarnToday() {
      const data = [
        { name: "重复开关门", value: 365 },
        { name: "非平层停梯", value: 365 },
        { name: "非平层开门", value: 365 },
        { name: "蹲底", value: 365 },
        { name: "困人（AI）", value: 365 },
        { name: "开门故障", value: 365 },
      ];
      const total = data.reduce((sum, item) => sum + item.value, 0);
      const colors = ["#3385FF", "#00CCFF", "#00FFFF", "#FF9933", "#FF3333", "#FFD700"];
      const charts = echarts.init(document.getElementById("warnToday"));
      const option = {
        tooltip: {
          trigger: "item",
          formatter: "{b}：{c} ({d}%)",
        },
        // legend: {
        //   orient: "vertical",
        //   right: 10,
        //   top: 20,
        //   itemWidth: 10,
        //   itemHeight: 10,
        //   textStyle: {
        //     color: "#fff",
        //     fontSize: 12,
        //   },
        //   formatter: (name) => {
        //     const item = data.find((d) => d.name === name);
        //     const percent = ((item.value / total) * 100).toFixed(2);
        //     return `${name}  ${item.value} (${percent}%)`;
        //   },
        // },
        series: [
          {
            name: "告警类型",
            type: "pie",
            radius: ["55%", "70%"],
            center: ["50%", "50%"],
            avoidLabelOverlap: false,
            label: {
              show: false,
            },
            labelLine: {
              show: false,
            },
            color: colors,
            data,
          },
        ],
      };
      charts.setOption(option);
    },
    initWarnTime() {
      // const xData = ["5/21", "5/22", "5/23", "5/24", "5/25", "5/26"];
      const xData = this.thirtyWarnTime.map((item) => {
        return item.faultType;
      });
      // const yData = [120, 200, 150, 80, 70, 110];
      const yData = this.thirtyWarnTime.map((item) => {
        return item.count;
      });
      const charts = echarts.init(document.getElementById("warnTime"));
      const option = {
        backgroundColor: "transparent",
        tooltip: {
          trigger: "axis",
        },
        grid: {
          top: 50,
          left: 40,
          right: 10,
          bottom: 30,
        },
        xAxis: {
          type: "category",
          data: xData,
          axisLabel: {
            color: "#fff",
          },
          axisLine: {
            lineStyle: {
              color: "#3A4F66",
            },
          },
        },
        yAxis: {
          name: "单位：次",
          type: "value",
          axisLabel: {
            color: "#fff",
          },
          splitLine: {
            lineStyle: {
              color: "#3A4F66",
              type: "dashed",
            },
          },
          nameTextStyle: {
            color: "#fff",
          },
        },
        series: [
          {
            name: "数量",
            type: "line",
            smooth: true,
            symbol: "circle",
            symbolSize: 8,
            data: yData,
            lineStyle: {
              color: "#FFB91D", //折线颜色
            },
            itemStyle: {
              color: "#FFB91D", //折点颜色
              borderColor: "#fff",
              borderWidth: 1,
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "rgba(0,198,255,0.4)" },
                { offset: 1, color: "rgba(0,198,255,0)" },
              ]),
            },
          },
        ],
      };
      charts.setOption(option);
    },
    initWarnTypeSeven() {
      // const data = [
      //   { name: "05/21", value: 30 },
      //   { name: "05/22", value: 20 },
      //   { name: "05/23", value: 15 },
      //   { name: "05/24", value: 5 },
      //   { name: "05/25", value: 23 },
      //   { name: "05/26", value: 66 },
      // ];
      const data = this.sevenWarn.map((item) => {
        return {
          name: item.faultType,
          value: item.count,
        };
      });
      const xData = data.map((item) => item.name);
      const yData = data.map((item) => item.value);
      const charts = echarts.init(document.getElementById("warnTypeSeven"));
      const option = {
        backgroundColor: "transparent",
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        grid: {
          top: 50,
          left: 10,
          right: 20,
          bottom: 20,
          containLabel: true,
        },
        xAxis: {
          type: "category",
          data: xData,
          axisLabel: {
            color: "#fff",
            fontSize: 12,
          },
          axisLine: {
            lineStyle: {
              color: "#3A4F66",
            },
          },
        },
        yAxis: {
          name: "单位：%",
          type: "value",
          axisLabel: {
            color: "#fff",
            fontSize: 12,
          },
          splitLine: {
            lineStyle: {
              color: "#3A4F66",
              type: "dashed",
            },
          },
          nameTextStyle: {
            color: "#fff",
            padding: [0, 0, 0, 0],
          },
        },
        series: [
          {
            // name: "%",
            type: "bar",
            barWidth: 20,
            data: yData,
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "#00FFFF" },
                { offset: 1, color: "#0E697D" },
              ]),
            },
          },
        ],
      };
      charts.setOption(option);
    },
    initWarnType() {
      // const data = [
      //   { name: "曳引系统", value: 4200 },
      //   { name: "导向系统", value: 800 },
      //   { name: "电器系统", value: 1900 },
      //   { name: "人为因素", value: 200 },
      //   { name: "门系统故障", value: 2300 },
      //   { name: "其他因素", value: 100 },
      // ];
      const data = this.thirtyWarnType.map((item) => {
        return {
          name: item.faultType,
          value: item.count,
        };
      });
      const xData = data.map((item) => item.name);
      const yData = data.map((item) => item.value);
      const charts = echarts.init(document.getElementById("warnTypeThirty"));
      const option = {
        backgroundColor: "transparent",
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        grid: {
          top: 50,
          left: 40,
          right: 20,
          bottom: 20,
          containLabel: true,
        },
        // xAxis: {
        //   type: "category",
        //   data: xData,
        //   axisLabel: {
        //     color: "#fff",
        //     fontSize: 12,
        //   },
        //   axisLine: {
        //     lineStyle: {
        //       color: "#3A4F66",
        //     },
        //   },
        // },
        xAxis: {
          type: "category",
          data: xData,
          axisLabel: {
            color: "#fff",
            fontSize: 8,
            align: "center", // 文字水平居中
            rotate: 14, // 文字旋转角度
          },
          axisLine: {
            lineStyle: {
              color: "#3A4F66",
            },
          },
        },
        yAxis: {
          name: "单位：次",
          type: "value",
          axisLabel: {
            color: "#fff",
            fontSize: 12,
          },
          splitLine: {
            lineStyle: {
              color: "#3A4F66",
              type: "dashed",
            },
          },
          nameTextStyle: {
            color: "#fff",
            padding: [0, 0, 0, 0],
          },
        },
        series: [
          {
            name: "次数",
            type: "bar",
            barWidth: 20,
            data: yData,
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "#3399FF" },
                { offset: 1, color: "#003366" },
              ]),
            },
          },
        ],
      };
      charts.setOption(option);
    },
    initMalfunction() {
      const data = [
        { name: "3年以下", value: this.boardForm.threeYearsNumber },
        { name: "3-6年", value: this.boardForm.twoYearsNumber },
        { name: "6-9年", value: this.boardForm.sixYearsNumber },
        { name: "9-12年", value: this.boardForm.nineYearsNumber },
        { name: "12-15年", value: this.boardForm.twelveYearsNumber },
        { name: "15年以上", value: this.boardForm.fifteenYearsNumber },
      ];
      const total = data.reduce((sum, item) => sum + item.value, 0);
      const colors = ["#3385FF", "#00CCFF", "#00FFFF", "#FF9933", "#FF3333", "#FFD700"];
      const charts = echarts.init(document.getElementById("malfunction"));
      const option = {
        tooltip: {
          trigger: "item",
          formatter: "{b}：{c} ({d}%)",
        },
        legend: {
          orient: "vertical",
          right: 10,
          top: 20,
          itemWidth: 10,
          itemHeight: 10,
          textStyle: {
            color: "#fff",
            fontSize: 12,
          },
          formatter: (name) => {
            const item = data.find((d) => d.name === name);
            const percent = ((item.value / total) * 100).toFixed(2);
            return `${name}  ${item.value} (${percent}%)`;
          },
        },
        series: [
          {
            name: "告警类型",
            type: "pie",
            radius: ["50%", "70%"],
            center: ["30%", "50%"],
            avoidLabelOverlap: false,
            label: {
              show: false,
            },
            labelLine: {
              show: false,
            },
            color: colors,
            data,
          },
        ],
      };
      charts.setOption(option);
    },
  },
};
</script>
<style lang="scss" scoped>
.page_main {
  // width: 1720px;
  // height: 1032px;
  margin-top: 10px;
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  .left {
    .general_box {
      width: 100%;
      .general_content {
        background: url("@/assets/image/g1.png") no-repeat center;
        background-size: 100% 100%;
        height: 220px;
        padding: 15px 20px;
        display: flex;
        align-items: center;
        .item_box {
          flex: 1;
          height: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: space-between;
          .item_list {
            height: 50px;
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            .icon {
              height: 100%;
              width: 64px;
            }
            .list_desc {
              height: 100%;
              display: flex;
              flex-direction: column;
              align-items: flex-start;
              justify-content: center;
              margin-left: 10px;
              .label {
                font-weight: 400;
                font-size: 14px;
                color: #b8c6d3;
              }
              .num {
                font-family: D-DIN;
                font-weight: 700;
                font-size: 18px;
                color: #fff;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
                width: 120px;
                span {
                  font-size: 12px;
                }
              }
            }
          }
        }
        .line {
          height: 100%;
          width: 1px;
          background: #00ffff;
          margin: auto 20px;
        }
      }
    }
    .thirtydays_box {
      margin-top: 7px;
      width: 100%;
      flex: 1;
      .thirtydays_content {
        height: calc(100% - 60px);
        width: 100%;
        background: url("@/assets/image/g1.png") no-repeat center;
        background-size: 100% 100%;
      }
    }
  }
  .center {
    width: calc(50% - 10px);
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    .map_box {
      width: 100%;
      flex: 1;
      position: relative;
      .back {
        position: absolute;
        margin: auto;
        cursor: pointer;
        left: 0;
        top: 0;
        background: url("@/assets/image/back.png") no-repeat center;
        background-size: 100% 100%;
        width: 124px;
        height: 36px;
        z-index: 999;
      }
      .map_content {
        width: 100%;
        height: 100%;
      }
    }
    .center_bottom {
      width: 100%;
      display: flex;
      justify-content: space-between;
      .charts_bottom_box {
        width: calc(50% - 10px);
      }
    }
  }
  .right {
    .today_warn_box {
      width: 100%;
      .today_warn_content {
        background: url("@/assets/image/g1.png") no-repeat center;
        background-size: 100% 100%;
        height: 280px;
        padding: 15px 20px;
        display: flex;
        align-items: center;
        .today_charts {
          width: 50%;
          height: 100%;
        }
        .today_legend {
          width: 50%;
          height: 100%;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          justify-content: space-evenly;
          .legend_list {
            height: 48px;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            width: 100%;
            .icon {
              width: 66px;
              height: 48px;
            }
            .line {
              height: 40px;
              width: 1px;
              margin: auto 20px;
            }
            .value_box {
              display: flex;
              flex-direction: column;
              align-items: flex-start;
              justify-content: space-between;
              .status {
                display: flex;
                align-items: center;
                font-weight: 400;
                font-size: 14px;
                color: #00cb61;
                .arrow {
                  margin-right: 10px;
                  width: 14px;
                  height: 12px;
                }
                &.warn {
                  color: #e2b400;
                }
                &.danger {
                  color: #d01c00;
                }
              }
              .value {
                width: 25px;
                height: 26px;
                font-family: D-DIN;
                font-weight: 700;
                font-size: 24px;
                color: #fff;
                line-height: 26px;
              }
            }
          }
        }
      }
    }
    .real_time {
      width: 100%;
      flex: 1;
      overflow: hidden;
      margin-bottom: 5px;
      // height: calc(100% - 500px);

      .real_content {
        height: calc(100% - 42px);
        width: 100%;
        background: url("@/assets/image/g1.png") no-repeat center;
        background-size: 100% 100%;
        display: flex;
        align-items: center;
        justify-content: center;

        .real_box {
          height: calc(100% - 30px);
          width: calc(100% - 40px);
          overflow: hidden;

          .real_list {
            height: 50%;
            display: flex;
            width: 100%;
            align-items: center;
            justify-content: center;
            .item_list {
              display: flex;
              width: calc(100% - 20px);
              padding: 0 10px;
              background: rgba(8, 85, 150, 0.29);
              // width: 100%;
              height: calc(100% - 10px);
              flex-direction: column;
              .label_box {
                height: 55%;
                display: flex;
                align-items: center;
                border-bottom: 1px dashed #1e4f7b;
                .tag {
                  width: 70px;
                  height: 24px;
                  background: url("@/assets/image/warn_icon.png") no-repeat center;
                  background-size: 100% 100%;
                  text-align: center;
                  font-weight: 700;
                  font-size: 12px;
                  color: #fff;
                  line-height: 24px;
                }
                .tag2 {
                  margin-left: 10px;
                  background: rgba(79, 158, 232, 0.1);
                  box-shadow: inset 0px 0px 20px 0px rgba(0, 149, 250, 0.5);
                  border-radius: 60px 60px 60px 60px;
                  border: 1px solid #0095fa;
                  padding: 4px 13px;
                  font-weight: 400;
                  font-size: 12px;
                  color: #fff;
                }
                .time {
                  font-weight: 400;
                  font-size: 12px;
                  color: #b8c6d3;
                  text-align: right;
                  flex: 1;
                }
                .text {
                  font-weight: 700;
                  font-size: 12px;
                  color: #fff;
                  margin-right: 6px;
                }
              }
              .warn_bottom {
                display: flex;
                align-items: center;
                flex: 1;
                width: 100%;
                justify-content: space-between;
              }
            }
          }
        }
      }
    }
    .use_box {
      overflow: hidden;
      .unit_list {
        padding: 0 30px;
        .sort_item {
          display: flex;
          flex-direction: column;
          justify-content: space-evenly;
          height: 100%;
          width: 100%;
          .sort_info {
            display: flex;
            align-items: center;
            .icon {
              width: 16px;
              height: 16px;
              margin-right: 6px;
            }
            .sort {
              font-weight: 700;
              font-size: 12px;
              color: #fff;
            }
            .value {
              flex: 1;
              text-align: right;
              font-weight: 700;
              font-size: 12px;
              color: #00abfa;
              &.first {
                color: #ff9900;
              }
            }
          }
          .process_box {
            width: 100%;
            height: 4px;
            background: rgba(255, 185, 29, 0.1);
            .process {
              height: 100%;
              background: linear-gradient(270deg, #00abfa 0%, #90e3ff 100%);
              position: relative;
              &.active {
                background: linear-gradient(270deg, #ff9900 0%, #fad789 100%);
              }
              .process_line {
                position: absolute;
                margin: auto;
                right: 0;
                top: 0;
                bottom: 0;
                width: 2px;
                height: 8px;
                background: #fff;
                border-radius: 1px;
              }
            }
          }
        }
      }
    }
  }
  .side_list {
    width: calc((100% - 60px) / 4);
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .charts_bottom_box {
    width: 100%;
    .charts_container {
      height: 180px;
      margin-top: 6px;
      background: url("@/assets/image/bottom_bg.png") no-repeat center;
      background-size: 100% 100%;
    }
  }
  .item_box {
    display: flex;
    flex-direction: column;
    width: 100%;
    .item_title_box {
      width: calc(100% - 40px);
      height: 36px;
      background: url("@/assets/image/box_title_bg.png") no-repeat center;
      background-size: 100% 100%;
      margin-bottom: 6px;
      font-family: YouSheBiaoTiHei;
      font-weight: 400;
      font-size: 24px;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      padding-left: 40px;
    }
  }
}
.nothing {
  width: 22%;
  margin: auto;
}
</style>
